// src/components/Menu/SyncUploadScreen.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
} from '@mui/material';
import { harmonateTokens as ht } from '../../theme/harmonateTokens';
import {
  harmonatePageSx,
  harmonatePageTitleSx,
  harmonateCardSx,
  harmonateProceedButtonSx,
  harmonateFormFieldsSx,
} from '../../theme/harmonateStyles';

const SyncUploadScreen = () => {
  const navigate = useNavigate();
  const [sourceGL, setSourceGL] = useState('Efront');
  const [destinationGL, setDestinationGL] = useState('Allvue');
  const [isFileUploaded, setIsFileUploaded] = useState(false);

  const handleFileUpload = () => {
    // Simulate file upload
    setIsFileUploaded(true);
  };

  const handleApproveClick = () => {
    if (isFileUploaded) {
      console.log("Navigating to /gl-sync/mapping");
      navigate('/gl-sync/mapping', { state: { sourceGL, destinationGL } });
    } else {
      console.log("Navigating to /gl-sync/upload");
      navigate('/gl-sync/upload', { state: { sourceGL, destinationGL } });
    }
  };

  return (
    <Box sx={{ ...harmonatePageSx, ...harmonateFormFieldsSx }}>
      <Typography variant="h6" sx={{ ...harmonatePageTitleSx, mb: 2 }}>
        Source Upload
      </Typography>

      <Box sx={{ display: 'flex', gap: 4, mb: 4 }}>
        <Box sx={{ width: '50%' }}>
          <FormControl fullWidth sx={{ mb: 2, bgcolor: ht.white, borderRadius: ht.fieldRadius }}>
            <InputLabel>Source GL</InputLabel>
            <Select
              value={sourceGL}
              label="Source GL"
              onChange={(e) => setSourceGL(e.target.value)}
            >
              <MenuItem value="Efront">Efront</MenuItem>
              <MenuItem value="Allvue">Allvue</MenuItem>
              <MenuItem value="Investran">Investran</MenuItem>
              <MenuItem value="Paxus">Paxus</MenuItem>
            </Select>
          </FormControl>

          <Paper elevation={0} sx={{ ...harmonateCardSx, p: 3, textAlign: 'center', mb: 2, bgcolor: ht.white }}>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Drag your field or browse
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Max 10 MB File size allowed
            </Typography>
            <Button
              variant="contained"
              sx={{ ...harmonateProceedButtonSx, mt: 2 }}
              onClick={handleFileUpload}
            >
              Upload
            </Button>
          </Paper>

          {isFileUploaded && (
            <Paper elevation={0} sx={{ ...harmonateCardSx, p: 2, mb: 2, bgcolor: ht.white }}>
              <Typography variant="body1">{sourceGL}.xlsx</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                <CircularProgress variant="determinate" value={50} size={20} thickness={5} sx={{ color: ht.green }} />
                <Typography variant="body2">50%</Typography>
              </Box>
            </Paper>
          )}

          <Typography variant="body2" sx={{ mb: 2, color: ht.white }}>
            Entity Detail • Transactions/Commitments • Trial Balance • Bank Accounts • Allocation
          </Typography>
        </Box>

        <Box sx={{ width: '50%' }}>
          <FormControl fullWidth sx={{ mb: 2, bgcolor: ht.white, borderRadius: ht.fieldRadius }}>
            <InputLabel>Destination GL</InputLabel>
            <Select
              value={destinationGL}
              label="Destination GL"
              onChange={(e) => setDestinationGL(e.target.value)}
            >
              <MenuItem value="Efront">Efront</MenuItem>
              <MenuItem value="Allvue">Allvue</MenuItem>
              <MenuItem value="Investran">Investran</MenuItem>
              <MenuItem value="Paxus">Paxus</MenuItem>
            </Select>
          </FormControl>

          <Paper elevation={0} sx={{ ...harmonateCardSx, p: 3, textAlign: 'center', mb: 2, bgcolor: ht.white }}>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Drag your field or browse
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Max 10 MB File size allowed
            </Typography>
            <Button
              variant="contained"
              sx={{ ...harmonateProceedButtonSx, mt: 2 }}
              onClick={handleFileUpload}
            >
              Upload
            </Button>
          </Paper>

          {isFileUploaded && (
            <Paper elevation={0} sx={{ ...harmonateCardSx, p: 2, mb: 2, bgcolor: ht.white }}>
              <Typography variant="body1">{destinationGL}.xlsx</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                <CircularProgress variant="determinate" value={50} size={20} thickness={5} sx={{ color: ht.green }} />
                <Typography variant="body2">50%</Typography>
              </Box>
            </Paper>
          )}

          <Typography variant="body2" sx={{ mb: 2, color: ht.white }}>
            Entity Detail • Transactions/Commitments • Trial Balance • Bank Accounts • Allocation
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          variant="contained" 
          sx={harmonateProceedButtonSx}
          onClick={handleApproveClick}
        >
          Approve
        </Button>
      </Box>
    </Box>
  );
};

export default SyncUploadScreen;